export default "__VITE_ASSET__BaLIk5AN__"